import React from 'react'
import Progress from "../contexts/ProgressContext"
import "../css/progressbar.css";

//firebase
import { useState, useEffect } from "react";
import { db } from "../firestore-db";
import 'firebase/compat/firestore';
import {
    collection
} from "firebase/firestore";


import { useAuth } from "../contexts/AuthContext"
import { useNavigate } from "react-router-dom"

export default function ProgressBar() {
    const { currentUser, logout, login } = useAuth()
    const [value, setValue] = useState(0);
    const navigate = useNavigate()

    var userTypeCheck;
    var uid = currentUser.uid;
    var isUser;

    useEffect(() => {
        const getUsersData = async () => {

            await db.collection("admin").where("userID", "==", uid)
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        userTypeCheck = doc.data().userType;

                        if (userTypeCheck != null) {
                            console.log("usertype check ==> " + userTypeCheck);
                            isUser = userTypeCheck;
                        } else {
                            console.log("current user is null/undefine");
                            isUser = "nonAdmin";
                        }

                    });
                })
                .catch((error) => {
                    console.log("Error getting documents: ", error);
                });

        };

        getUsersData();
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setValue(oldValue => {
                const newValue = oldValue + 15;

                async function checkUser() {
                    if (newValue >= 100) {
                        clearInterval(interval);
    
                        if (isUser == "admin") {
                            console.log("usertype Admin? ==> " + isUser);
                            navigate("/dashboard");
                        } else {
                            console.log("usertype Non Admin? ==> " + isUser);
                            await logout()
                            navigate("/login");
                        }
                    }
                }

                checkUser();
                return newValue;
            });
        }, 1000);
    }, []);

    return (
        <div className='progress-container'>
            <h3 id="spin-text">  </h3>
            <Progress color={"#069"} width={"550px"} value={value} max={100} />
        </div>
    )
}
